import AbstractBasicInput, { BasicInputProps, BasicInputState } from "../AbstractBasicInput";


export class BasicInput extends AbstractBasicInput<BasicInputProps, BasicInputState> {

}

export default BasicInput;